"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Shader_1 = require("../../tree/Shader");
class C2dShader extends Shader_1.Shader {
    beforeDraw(operation, target) {
        // Noop
    }
    draw(operation, target) {
        // Noop
    }
    afterDraw(operation, target) {
        // Noop
    }
}
exports.C2dShader = C2dShader;
//# sourceMappingURL=C2dShader.js.map